


















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class InputField extends Vue {
  @Prop({ default: "" })
  private placeholderText?: string;
  @Prop({ default: "text" })
  private inputType?: string;
  @Prop({ default: 100 })
  private maxTextLength?: number;
  @Prop({ default: true })
  private border?: boolean;
  @Prop({ default: false })
  private autofocus?: boolean;
  @Prop({ default: false })
  private focused?: boolean;

  private inputValue: string | number = "";

  private mounted() {}

  @Watch("inputValue", { immediate: true })
  private onChildChanged(val: string, oldVal: string) {
    this.$emit("input", val);
  }

  @Emit("clickClear")
  private clickClear() {
    this.inputValue = "";
  }

  private _keydown(val: any) {
    this.$emit("input", val.data)
  }
}
